import { CardOrderBase } from "./CardOrderBase";

export class CardOrderDriverCard extends CardOrderBase {
    KortBrugerEfternavn: string = "";
    KortBrugerFornavn: string = "";
    FoedselsDato: Date | null = null;
    PostAdresseNavn: string = "";
    PostAdresseVejOgNr: string = "";
    PostAdresseStedNavn: string = "";
    PostAdressePostNr: string = "";
    PostAdressePostDistrikt: string = "";
    GyldighedStartDato: Date | null = null;
    KortNrTidligereKort: string | null = "";
    UdloebsDato: Date | null = null;
    UdstedendeMyndighed: string = "";
    PersonNr: string = "";
    KoerekortNr: string = "";
    KoereKortNationalitet: string = "";
    KoerekortUdstedendeMyndighed: string = "";
    Antal: string = "";
    Malfunctioning: boolean = false;
    FotoData: string = "";
    IsAndenGeneration: string = "";

    //These values are always null, based on looking at older orders.
    MekanikerPostNr: string | null = null;
    KortEjerAdresse: string | null = null;
    StamkortReferenceNr: string | null = null;
    CoNavn: string | null = null;
}

